<div class="information-box">
    <div class="information-box-header">
        <div class="information-box-title">
            <i [class]="'fa ' + icon + ' information-box-icon'"></i>
            <span class="information-box-main-title">{{title}}</span>
            <span *ngIf="subTitle" class="information-box-sub-title">{{subTitle}}</span>
        </div>

        <ac-button (click)="navigate.emit($event)" class="information-box-navigation">Discover more</ac-button>
    </div>

    <div class="information-box-container">
        <ng-content></ng-content>
    </div>

</div>
